import React from 'react';
// import { withRouter } from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import Drawer from 'material-ui/Drawer';
import UserLogIn from './UserLogIn';
import UserGuest from './UserGuest';

// @withRouter

@inject('sideBarStore')
@inject('userStore')
@observer
export default class extends React.Component {

  handleSidebar = () => {
    this.props.sideBarStore.activate();
  };

  // componentDidMount(){
  //   this.routerListener = this.props.history.listen(() => {
  //     this.props.sideBarStore.deactivate();
  //   });
  // }
  //
  // componentWillUnmount(){
  //   this.routerListener();
  // }

  sidebarHolder =() =>{
      if(!this.props.userStore.user){
          return(<UserGuest/>)
      } else{
          return(<UserLogIn/>)
      }
  };

  render(){
    const sideBarActive = this.props.sideBarStore.isActive;
    const sideBarWrapper = this.sidebarHolder();
    return (
      <div>
        <Drawer
          docked={false}
          containerClassName="sidebar"
          width={320}
          open={sideBarActive}
          openSecondary={true}
          onRequestChange={this.handleSidebar}
        >
          {sideBarWrapper}
        </Drawer>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/modules/core/containers/Sidebar.js